/* istanbul ignore file */
export * from './RatingIconsVerified';
